import { getRegisteredContentBlockTypes } from '../register-content-block'

import type { ContentBlocksAndAdSlotMarkers } from '../types/content-block-types'
import type { NewContentBlock } from '../stores/content-block-store'
import type { ContentBlock } from '../../utils/content-block-schema'

export function paragraphsToContentBlock (paragraphs: ContentBlock[] = []): NewContentBlock<ContentBlocksAndAdSlotMarkers>[] {
  const contentBlocks: NewContentBlock<ContentBlocksAndAdSlotMarkers>[] = []
  const registeredContentBlockTypes = getRegisteredContentBlockTypes()

  for (const paragraph of paragraphs) {
    if (!registeredContentBlockTypes.includes(paragraph?.paragraphType)) {
      // We do not recognize this paragraph type, so we skip it
      continue
    }

    const index = paragraphs.indexOf(paragraph)
    const contentBlock = {
      id: index.toString(),
      type: paragraph.paragraphType,
      data: paragraph,
      dimensions: {
        width: 0,
        height: 0,
        fromTop: 0,
        innerWidth: 0,
        innerHeight: 0
      },
      enabled: true
    } satisfies NewContentBlock<ContentBlocksAndAdSlotMarkers>

    contentBlocks.push(contentBlock)
  }

  return contentBlocks
}
